import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { getLoggedInUserHltId } from "utils/CommonFunctions";

const Pendo = () => {
  const location = useLocation();

  const hltId = getLoggedInUserHltId();

  const path = location.pathname;

  const innCodeData = useAppSelector((state: any) => state.app.innCode);
  const myPlanDetails = useAppSelector((state) => state.myPlanDetails?.myPlanDetails);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const visitor = { id: isImpersonated ? `impersonate${hltId}` : hltId };

  useEffect(() => {
    if (window.pendo) {
      window.pendo.initialize({
        visitor,
        account: {
          id: getInncode()
        }
      });
    }
  }, [path, myPlanDetails]);

  useEffect(() => {
    if (window.pendo) {
      window.pendo.updateOptions({
        visitor,
        account: {
          id: getInncode()
        }
      });
    }
  }, [innCodeData, path, myPlanDetails]);

  const getInncode = () => {
    const currPath = path.split("/")[1];
    let inncode;

    switch (currPath) {
      case "myplandetails": {
        inncode = myPlanDetails.innCode;
        break;
      }
      case "property": {
        inncode = path.split("/")[2];
        break;
      }
      default: {
        inncode = innCodeData;

        break;
      }
    }
    return inncode;
  };
  return <></>;
};
export default Pendo;
